export default class Form {
    /**
     * Disabled status
     * @param status
     */
    public static statusDisabled(status: any) {
        switch (status) {
            case 1:
            case 2: {
                return true;
            }
        }

        return false;
    }
}
